export default {
  imageDomain: 'https://sp-image.pictlink.com',
  s3BucketForPublicResources: 'pictlink-public-files',
  cloudFrontPath: 'https://contents.pictlink.com',
  wordPressPath: 'https://blog.pictlink.com',
  pictlinkAuthPath: 'https://pictlink-auth.pictlink.com',
  identityVerifierPath: 'https://identity-verifier.pictlink.com'
}
